import APP_CONFIG from "lib/config";
import { TenantConfig } from "lib/tenant/types";
import { getNumberLocale } from "i18n";
import { ENV } from "./constants";

export const formatCurrency = (
  value: number | null | undefined,
  currency = "NGN",
  language?: string
): string => {
  const numberLocale = getNumberLocale(language);

  return new Intl.NumberFormat(numberLocale, {
    style: "currency",
    minimumFractionDigits: 0,
    currency,
    currencyDisplay: "narrowSymbol",
  }).format(value || 0);
};

export const convertParamsToString = (
  url: string,
  urlVariables: Record<string, string | any>
): string => {
  let finalURL = url;

  for (const [key, value] of Object.entries(urlVariables)) {
    finalURL = finalURL.replace(`:${key}`, value);
  }

  return finalURL;
};

export const chatOnWhatsApp = (message: string, phoneNo: string) => {
  const encodedText = encodeURI(message);
  window.open(`https://wa.me/${phoneNo.trim()}?text=${encodedText}`);
};

export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, (txt: string) => {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
}

function withLoginPath(url: string): string {
  const trimmed = url.replace(/\/+$/, "");
  if (/\/login$/i.test(trimmed)) {
    return trimmed;
  }
  return `${trimmed}/login`;
}

export function getWebAppLoginUrl(
  tenant?: Pick<TenantConfig, "webAppUrl" | "primaryDomain">
): string {
  const explicitUrl = tenant?.webAppUrl?.trim();
  if (explicitUrl) {
    return withLoginPath(explicitUrl);
  }

  const domain = tenant?.primaryDomain?.replace(/^www\./, "");
  if (domain) {
    const host =
      APP_CONFIG.CLIENT_ENV === ENV.PROD
        ? `www.app.${domain}`
        : `www.test-tkb026-app.${domain}`;
    return `https://${host}/login`;
  }

  return APP_CONFIG.CLIENT_ENV === ENV.PROD
    ? "https://www.app.getoze.com/login"
    : "https://www.test-app.getoze.com/login";
}

export const backToWebApp = (
  tenant?: Pick<TenantConfig, "webAppUrl" | "primaryDomain">
) => {
  window.location.href = getWebAppLoginUrl(tenant);
};
